/** @format */

import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const modernColors = [
  "#4F46E5",
  "#06B6D4",
  "#10B981",
  "#F59E0B",
  "#EF4444",
  "#8B5CF6",
];

const options = {
  indexAxis: "y",
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    title: {
      display: false,
    },
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          let label = context.dataset.label || "";
          if (label) {
            label += ": ";
          }
          label += context.raw + " m³/s";
          return label;
        },
      },
      backgroundColor: "rgba(0, 0, 0, 0.8)",
      titleColor: "#fff",
      bodyColor: "#ddd",
      borderColor: "#555",
      borderWidth: 1,
    },
    datalabels: {
      color: "#fff",
      formatter: (value) => `${value} m³/s`,
      font: {
        weight: "bold",
      },
    },
  },
  scales: {
    x: {
      beginAtZero: true,
      grid: {
        color: "rgba(200, 200, 200, 0.2)",
      },
      ticks: {
        color: "#555",
      },
    },
    y: {
      grid: {
        display: false,
      },
      ticks: {
        color: "#555",
      },
    },
  },
};

const labels = ["Andijon", "Farg‘ona", "Namangan"];

const BarChart2 = ({ d1 = 0, d2 = 0, d3 = 0 }) => {
  const data = {
    labels,
    datasets: [
      {
        label: "Qiymati",
        data: [d1, d2, d3],
        backgroundColor: modernColors,
        borderRadius: 4,
        barThickness: 40,
      },
    ],
  };

  return (
    <div style={{ height: "250px", padding: "10px" }}>
      <Bar options={options} data={data} />
    </div>
  );
};

export default BarChart2;
